"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Utilities_1 = require("../../Utilities");
var ScrollablePane_base_1 = require("./ScrollablePane.base");
var ScrollablePane_styles_1 = require("./ScrollablePane.styles");
exports.ScrollablePane = Utilities_1.styled(ScrollablePane_base_1.ScrollablePaneBase, ScrollablePane_styles_1.getStyles);
//# sourceMappingURL=ScrollablePane.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/office-ui-fabric-react/lib/components/ScrollablePane/ScrollablePane.js
// module id = 1046
// module chunks = 0